'use client'

import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'
import { Autoplay, EffectCreative } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'

import { cn } from '@/_lib/utils'

import AJobsHeroCard from './a-jobs-hero-card'

interface IAJobsHeroSwiperProps {
	className?: string
}

const AJobsHeroSwiper = ({ className }: IAJobsHeroSwiperProps) => {
	const t = useTranslations('pages.letsMakeWorldHealthier.benefits.cards')

	const slides: { title: string | ReactNode; icon: string; className: string }[] = [
		{
			title: t.rich('time.titleShort', {
				br: () => <br />
			}),
			icon: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/clock.svg`,
			className: 'bg-m-purple-3 text-m-purple'
		},
		{
			title: t.rich('family.titleShort', {
				br: () => <br />
			}),
			icon: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/heart.svg`,
			className: 'bg-m-cyclamen-3/80 text-m-purple'
		},
		{
			title: t.rich('devices.titleShort', {
				br: () => <br />
			}),
			icon: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/stethoscope.svg`,
			className: 'bg-m-turquoise-3/80 text-m-purple'
		},
		{
			title: t.rich('spaces.titleShort', {
				br: () => <br />
			}),
			icon: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/medante-clinic.svg`,
			className: 'bg-m-blue-3 text-m-purple'
		}
	]

	return (
		<div className={cn('min-w-0', className)}>
			<Swiper
				modules={[Autoplay, EffectCreative]}
				effect='creative'
				className='overflow-hidden rounded-3xl h-full'
				creativeEffect={{
					prev: {
						translate: ['-100%', 0, -1],
						opacity: 0
					},
					next: {
						translate: ['100%', 0, 0]
					}
				}}
				slidesPerView={1}
				loop
				autoplay={{
					delay: 2000,
					disableOnInteraction: false
				}}
			>
				{slides.map((slide, index) => (
					<SwiperSlide key={index} className='h-full'>
						<AJobsHeroCard
							title={slide.title}
							icon={slide.icon}
							className={slide.className}
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	)
}

export default AJobsHeroSwiper
